module.exports = __webpack_public_path__ + "static/media/14a-02_ST-2014-130x95cm-oleo-y-aceite-de-lino-sobre-papel.f3878d8d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/gallery/14a/14a-02_ST-2014-130x95cm-oleo-y-aceite-de-lino-sobre-papel.jpg
// module id = 145
// module chunks = 0